import { useCallback } from 'react'
import { loginUrl, resetByCodeUrl, sendResetCodeUrl } from '../providers/EnvContextProvider'
import { useOperatorContext } from '../comps/login/OperatorContextProvider';
import { useTokensContext } from '../providers/TokensContextProvider';

export default function useAuth() {

  const {setOperator, dispatchOperatorFlag, OperatorFlag} = useOperatorContext();
  const {setIdToken, setAccessToken}                      = useTokensContext();  

  const resetByCode = useCallback( async (resetCode, sessionCode, newPass)=>{
    return new Promise((resolve, reject) => {
      // Fetch LOGIN
      fetch(resetByCodeUrl, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'auth-reset-code': resetCode,
          'auth-session-code': sessionCode,
          'auth-new-pass': newPass
        }
      })
      .then(response => {          
        if (response.ok) {
          resolve(({
            msg: 'Ok',
            desc: 'Password updated successfully.'
          })); // also returned as success.          
        }
        else {
          response.json()
            .then(errorData => {
              reject(({      // also returned as error.
                errCode: response.status,
                errDesc: response.statusText,
                errData: errorData
              }))
            })
            .catch(jsonError => reject(({
              errCode: response.status,
              errDesc: 'Server Error: '+response.statusText,
              errData: jsonError
            })))          
        }
      })
      .catch(error => {
        console.error('[useAugh resetByCode] Reset Password Error: %s', JSON.stringify(error, null, 2));
        reject(({
          errCode: -1,
          errDesc: 'Unexpected Error',
          errData: error
        }));
      });
    });

  }, []);

  const sendResetCode = useCallback( async (emailOrUsername)=>{             
    return new Promise((resolve, reject) => {
      // Fetch LOGIN
      fetch(sendResetCodeUrl, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'auth-reset': emailOrUsername,        
        }
      })
      .then(response => {          
        if (response.ok) {
          resolve(({
            sessionCode: response.headers.get('auth-session-code'),
            msg: 'Ok',
            desc: 'If account exist, an email was sent'
          })); // also returned as success.          
        }
        else {

          response.json()
            .then(errorData => {
              reject(({      // also returned as error.
                errCode: response.status,
                errDesc: response.statusText,
                errData: errorData
              }))
            })
            .catch(jsonError => reject(({
              errCode: response.status,
              errDesc: 'Server Error: '+response.statusText,
              errData: jsonError
            })))          
        }
      })
      .catch(error => {
        console.error('[useAugh sendResetCode] Send-Reset-Code Error: %s', JSON.stringify(error, null, 2));
        reject(({
          errCode: -1,
          errDesc: 'Unexpected Error',
          errData: error
        }));
      });
    });
  },[]);

  //------ Login ------
  //
  const login = useCallback((username, passwd) => {

    // On Login Success
    // 
    const onLoginSuccess = (response) => {
      if (response.ok) {
        console.log('[useAuth.login] At response.ok');
        const idToken = response.headers.get('auth-id-token');
        const accessToken = response.headers.get('authorization');      

        // const tokens = {
        //   'idToken': idToken,
        //   'accessToken': accessToken,
        //   'hasWsCookie': 'true'
        // };

        response.json()
          .then(user => {
            console.log('[useAuth] Login Response Parsed User: %s', JSON.stringify(user, null, 2));
            
            setOperator(user);
            setIdToken(idToken);
            setAccessToken(accessToken);
            dispatchOperatorFlag(OperatorFlag.Ready);
          })
          .catch(error => console.error(error));
      }
      else {
        console.error('[useAuth.login] At response NOT OK: %s', JSON.stringify(response, null, 2));
      }
    }

    // On Login Error
    //
    const onLoginError = (error) => {
      console.error('[useAuth.login] At onLoginError [error: %s]', JSON.stringify(error, null, 2));
      
    }

    // On Finally
    //
    const onFinally = () => {      
      console.log('[useAuth.login] At Finally');      
    }


    // Fetch LOGIN
    fetch(loginUrl, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'auth-u': username,
        'auth-p': passwd
      }
    })
    .then(onLoginSuccess)
    .catch(onLoginError)
    .finally(onFinally)

  }, [OperatorFlag.Ready, dispatchOperatorFlag, setIdToken, setAccessToken, setOperator]);


  //------  Return  ------
  //
  return {
    login,
    sendResetCode,
    resetByCode
  }
};
